module.exports = __webpack_public_path__ + "static/media/Personalized_Patterns_City_Skyline.111fa010.png";